import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SEOHead from '@/components/SEOHead';
import Footer from '@/components/Footer';
import { Button } from '@/components/ui/button';
import { LogoText } from '@/components/ui/Logo';
import IntegrationsDirectoryGrid from '@/components/integrations/IntegrationsDirectoryGrid';

export default function IntegrationsDirectoryPage() {
  const { t } = useTranslation('integrations');

  return (
    <div className="min-h-screen bg-background font-outer">
      <SEOHead
        title={t('directory.seoTitle')}
        description={t('directory.seoDescription')}
        keywords={[
          'Memara integrations',
          'AI memory',
          'ChatGPT',
          'Claude',
          'MCP',
          'Zapier',
          'n8n',
          'automation',
          'X bookmarks',
          'X (formerly Twitter) bookmarks Memara',
        ]}
      />
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      <header className="border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
        <div className="container mx-auto px-4">
          <div className="flex h-16 items-center justify-between">
            <LogoText variant="dark" size="md" iconSize={32} className="text-foreground" />
            <div className="flex items-center space-x-4">
              <Button variant="ghost" size="sm" asChild>
                <Link to="/">{t('directory.navHome')}</Link>
              </Button>
              <Button variant="ghost" size="sm" asChild>
                <Link to="/docs">{t('directory.navDocs')}</Link>
              </Button>
              <Button asChild size="sm">
                <Link to="/login">{t('directory.navSignIn')}</Link>
              </Button>
            </div>
          </div>
        </div>
      </header>
      <main id="main-content" className="container mx-auto max-w-6xl px-4 py-12 md:py-16">
        <div className="mx-auto mb-10 max-w-2xl text-center">
          <h1 className="mb-3 text-3xl font-bold tracking-tight text-foreground md:text-4xl">
            {t('directory.title')}
          </h1>
          <p className="text-muted-foreground md:text-lg">{t('directory.subtitle')}</p>
          <p className="mt-4 text-sm text-muted-foreground">{t('directory.signInHint')}</p>
        </div>
        <IntegrationsDirectoryGrid />
      </main>
      <Footer />
    </div>
  );
}
